<template>
  <div class="flex flex-col" data-testid="components-ui-sk-select-sk-text-select-div">
    <slot
      name="activator"
      :toggle="toggleModal"
      :title="title"
      :is-opened="isOpened"
    />
  

    <div class="relative" data-testid="components-ui-sk-select-sk-text-select-div-2">
      <Transition data-testid="components-ui-sk-select-sk-text-select-transition">
        <div
          v-if="isOpen"
          class="sk-menu"
         data-testid="components-ui-sk-select-sk-text-select-div-3">
          <template
            v-for="(item, index) in items"
            :key="index"
          >
            <div
              class="sk-menu__item"
              @click.stop="selectItem(item)"
             data-testid="components-ui-sk-select-sk-text-select-div-4">
              <template v-if="itemValue">
                {{ item[itemTitle] }}
              </template>

              <template v-else>
                {{ item }}
              </template>
            </div>

            <div
              v-if="index < items.length - 1"
              class="sk-menu__divider"
            data-testid="components-ui-sk-select-sk-text-select-div-5" />
          </template>
        </div>
      </Transition>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'

const emit = defineEmits(["update:modelValue"])

const props = defineProps({
  modelValue: {
    type: [String, Object],
    default: ''
  },
  items: {
    type: Array,
    default: () => []
  },
  itemTitle: {
    type: [String, Number], 
    default: ''
  },
  itemValue: {
    type: [String, Number], 
    default: ''
  },
})

const isOpen = ref(false)

const title = computed(() => props.itemValue ? selected.value[props.itemTitle] : selected.value)

const isOpened = computed(() => isOpen.value)

const selected = computed({
  get() {
    return props.modelValue
  },
  set(val) {
    emit("update:modelValue", val)
  }
})

const toggleModal = () => {
  isOpen.value = !isOpen.value
}

const closeModal = () => {
  isOpen.value = false
}

const selectItem = (item) => {
  selected.value = item

  closeModal()
}
</script>

<style lang="scss" scoped>
.sk-menu {
  position: absolute;
  border: 1px solid #DCE1E7;
  border-radius: 12px;
  top: 0;
  margin-top: 2px;
  z-index: 2001;
  overflow: hidden;
  min-width: 177px;
  box-shadow: 0px 2px 8px 0px #00000014;

  &__item {
    padding: 6px 12px;
    font-size: 14px;
    line-height: 140%;
    color: #292929;
    background-color: #EDEFF3;
    transition: background-color 0.3s ease-out;
    cursor: pointer;

    &:hover {
      background-color: #F6F7FA;
    }
  }

  &__divider {
    border-top: 1px solid #DCE1E7;
  }
}

.v-enter-active,
.v-leave-active {
  transition: all 0.2s ease;
}

.v-enter-from,
.v-leave-to {
  transform: translateY(-5px);
  opacity: 0;
}
</style>